
import { Component, Prop, Vue } from 'vue-property-decorator'

import { AcompteListItem } from '../types/acompteList'

@Component({ name: 'AcompteListCard' })
export default class extends Vue {
  @Prop({ required: true }) acompte!: AcompteListItem

  get isPending(): boolean {
    return this.acompte.status === 'pending'
  }

  get pendingHintKey(): string {
    return this.acompte.reserved ? 'dotationOrders.acompte.pendingHintReserved' : 'dotationOrders.acompte.pendingHint'
  }

  get statusTag(): { type: string; label: string } {
    if (this.isPending) {
      return { type: 'warning', label: this.$t('dotationOrders.acompte.status.pending') as string }
    }
    return { type: 'success', label: this.$t('dotationOrders.acompte.status.validated') as string }
  }

  formatCurrency(amount: number): string {
    return this.$n(amount || 0, 'currency') as string
  }
}
